if(!customElements.get('collection-filters')) {
  class CollectionFilters extends HTMLElement {
    constructor() {
      super();

      this.elGrid = this.closest('collection-grid');
      this.elFiltersTemplate = this.querySelector('[data-filters-template]');
      this.elData = this.querySelector('[data-filters-data]');
      this.elClear = this.elGrid.querySelector('[data-filters-clear]');
      
      this.buildFilters();
      this.addEventListener('grid:loaded', this.buildFilters.bind(this));
    }

    buildFilters() {
      this.elFiltersTemplate.innerHTML = this.filtersHtml();
      this.elFilters = this.elGrid.querySelectorAll('[data-filter]');
      this.elClear = this.elGrid.querySelector('[data-filters-clear]');

      this.elClear && this.elClear.setAttribute('href', this.getActiveFilterValues().clearUrl);
      this.elFilters.forEach(el => el.addEventListener('click', this.filterCollection.bind(this)));
    }

    filterCollection(ev) {
      ev.preventDefault();
      const { currentTarget: elFilter } = ev;
      const { href: url } = elFilter;
      const elParent = elFilter.closest('[data-filter-parent]');
      const elOtherFilters = elParent.querySelectorAll('[data-filter]');

      this.elGrid.setCollection(url, false);
      elOtherFilters.forEach(el => {
        el.parentNode.classList.toggle('active', el == elFilter);
      })
    }

    filtersHtml() {
      const { filters } = JSON.parse(this.elData.innerHTML);
      return filters.map(filter => {
        const viewAllUrl = new URL(window.location.href);
        viewAllUrl.searchParams.delete(filter.param);

        return `
          <li class="collection-filters--filter" data-filter-parent>
            <strong class="collection-filters--filter-label">${filter.label}</strong>
            <ul class="collection-filters--filter-values">
              <li class="collection-filters--filter-value ${window.location.href == viewAllUrl ? 'active' : ''}">
                <a href="${viewAllUrl}" data-active-url="${viewAllUrl}" data-filter>
                  View All <span class="visually-hidden">Products</span>
                </a>
              </li>
              ${filter.values.map(value => {
                const { url, isActive } = this.getValueUrl(value);
                return `
                  <li class="collection-filters--filter-value ${isActive ? 'active' : ''}">
                    <a href="${url}" data-filter>
                      <span class="visually-hidden">${isActive ? 'Remove ' : `Filter collection by ${filter.label}: `} </span>${value.label}<span class="visually-hidden"> ${isActive ? ' Filter' : ''}</span>
                    </a>
                  </li>
                `
              }).join('')}
            </ul>
          </li>
        `
      }).join('')
    }

    getActiveFilterValues() {
      const { filters } = JSON.parse(this.elData.innerHTML);
      const values = filters.map(filter => filter.values).flat();
      const clearUrl = new URL(window.location.href);
      const activeValues = values.filter(value => {
        const { isActive } = this.getValueUrl(value);
        value.params.forEach(param => {
          clearUrl.searchParams.delete(param.name);
        })
        return isActive;
      });

      return {
        activeValues,
        clearUrl
      }
    }

    getValueUrl(value) {
      const url = new URL(window.location.href);
      const currentParamsArray = [...url.searchParams.entries()].map(arr => ({ [arr[0]]: arr[1] }));
      const currentParams = currentParamsArray.reduce((prv, cur) => {
        Object.entries(cur).forEach(([key, v]) => key in prv ? prv[key].push(v) : (prv[key] = [v]));
        return prv;
      }, {});

      const activeParams = value.params.filter(param => currentParams[param.name] && currentParams[param.name].includes(param.value));
      const isActive = !!activeParams.length;

      if(isActive) {
        activeParams.forEach(param => {
          url.searchParams.delete(param.name, param.value)
        });
      } else {
        value.params.forEach(param => {
          if(value.exclusive) {
            param.value ? url.searchParams.set(param.name, param.value) : url.searchParams.delete(param.name);
          } else {
            url.searchParams.append(param.name, param.value);
          }
        })
      }

      return {
        url,
        isActive
      };
    }
  }

  customElements.define('collection-filters', CollectionFilters);
}